import React from 'react';

/** Right-side help panel — does not push page content. */
function HowPacketsDrawer({ onClose }) {
  return (
    <div className="pp-drawer-root" role="presentation">
      <button type="button" className="pp-drawer-backdrop" aria-label="Close help" onClick={onClose} />
      <aside
        className="pp-drawer"
        role="dialog"
        aria-modal="true"
        aria-labelledby="pp-how-title"
      >
        <div className="pp-drawer-head">
          <h3 id="pp-how-title" className="pp-drawer-title">How Production Packets Work</h3>
          <button type="button" className="pp-drawer-close" aria-label="Close" onClick={onClose}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>

        <div className="pp-drawer-body">
          <ol className="pp-drawer-steps">
            <li>
              <span className="pp-drawer-step-label">Confirmed Project Information</span>
              <p>
                Select a project. Key details, including project, venue, schedule, and client information, are
                imported from the Event Production Sheet. Events that share a Copper ID stay separate when the
                load-in date or Drive folder is different. If a project has no Google Drive folder, the page
                flags it — add the folder on the Event Production Sheet before generating.
              </p>
            </li>
            <li>
              <span className="pp-drawer-step-label">Complete Packet Details</span>
              <p>
                Add the operational details the delivery and installation team needs, including origin departure,
                site logistics, travel and lodging, delivery team information, and operational alerts. Hard set
                and hard out come from the Event Production Sheet with the rest of the schedule.
              </p>
            </li>
            <li>
              <span className="pp-drawer-step-label">Generate + Keep Current</span>
              <p>
                Generate the branded Production Packet when details are ready. Supporting floor plans, timelines,
                and diagrams are pulled from the project’s Production Packet Resources folder in Drive when
                available. If supporting materials are missing, ask the Client Coordinator to provide them.
              </p>
              <p>
                If project information changes, regenerate the packet to capture the latest details. Always
                regenerate the Production Packet prior to event departure to ensure the team has the most current
                version.
              </p>
            </li>
          </ol>
        </div>
      </aside>
    </div>
  );
}

export default HowPacketsDrawer;
